(() => {
    const header = document.querySelector('[data-header]');
    const headerBackground = document.querySelector('[data-header-background]');

    if (header && headerBackground) {
        const image = new Image();
        const src = headerBackground.dataset.headerBackground;

        if (src) {
            image.addEventListener('load', () => {
                headerBackground.style.backgroundImage = `url('${src}')`;
                header.classList.add('animate');
            });
            image.src = src;
        } else {
            setTimeout(() => {
                header.classList.add('animate');
            }, 250);
        }

        const animate = () => {
            headerBackground.style.transform = `translate(0, ${window.pageYOffset *
                0.25}px)`;

            requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
    }
})();
